// src/lib/stock-shape-render.tsx
import type { ReactNode } from 'react'
import type { ShapeId, SvgVariant } from './stock-shapes'
import {
  RectangularSvg, RoundBarSvg, HexBarSvg, PlateSvg,
  TubeSvg, LAngleSvg, TSectionSvg, IrregularDrawingSvg,
} from './stock-shape-svgs'

type Variant = 'glyph' | 'card' | 'full'

const svgRenderers: Record<ShapeId, (v: Variant, vals?: Record<string, number>) => ReactNode> = {
  rectangular:   (v, vals) => <RectangularSvg variant={v} values={vals} />,
  round_bar:     (v, vals) => <RoundBarSvg     variant={v} values={vals} />,
  hex_bar:       (v, vals) => <HexBarSvg       variant={v} values={vals} />,
  plate:         (v, vals) => <PlateSvg        variant={v} values={vals} />,
  tube:          (v, vals) => <TubeSvg         variant={v} values={vals} />,
  l_angle:       (v, vals) => <LAngleSvg       variant={v} values={vals} />,
  t_section:     (v, vals) => <TSectionSvg     variant={v} values={vals} />,
  irregular_drawing: (v, vals) => <IrregularDrawingSvg variant={v} values={vals} />,
}

export function renderShapeSvg(
  id: ShapeId,
  variant: SvgVariant,
  values?: Record<string, number>,
): ReactNode {
  return svgRenderers[id](variant as Variant, values)
}
